module.exports = __webpack_public_path__ + "static/media/CUISINE_COMMUNS.3cae391a.jpg";